<template>
  <section class="slide-3 pl-4.5 w-screen">
    <p
      class="fz-10 font-medium color-gray uppercase"
      style="line-height: 1; letter-spacing: 0.3em"
    >
      {{ text.ourClients }}
    </p>
    <p class="fz-16 font-medium my-7.5 mr-4.5" style="line-height: 1.5625">{{text.trust}}</p>
    <slider
        :slides-container-classes="'mb-5'"
        :slider-classes="''"
        :similar-slides="true"
        :pagination="true"
        pagination-container-classes="gap-5 pl-4.5"
        class="mb-12.5"
    >
      <template v-slot:slides>
        <div
            class="slider-slide w-85 grid grid-rows-2 grid-cols-2"
            v-for="(item, index) in text.clientSliderM"
            :key="item"
        >
          <div class="w-42.5 h-42.5" v-for="(subItem, subIndex) in item" :class="subItem.opacity" :key="index + subIndex">
            <img :src="require('@/assets/images/slide_3/' + subItem.image + '.png')" style="width: inherit; height: inherit" class="client-list-item" alt="">
          </div>
        </div>
      </template>
      <template v-slot:pagination>
        <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
      </template>
    </slider>
    <div class="flex justify-between items-center w-90p">
      <div>
        <h3 class="fz-60 mb-1.25" style="color: #ff2e53">{{ text.realizedCount }}</h3>
        <p class="uppercase fz-10 font-medium w-50p" style="line-height: 2; color: #C0C5D8;">{{ text.realizedText[0] }} {{ text.realizedText[1] }}</p>
      </div>
      <div class="become-client flex flex-col items-end" @click="toggleContacts">
        <div class="plus relative w-12.5 h-12.5 rounded-full mb-2.5" style="background:#ff2e53;" >
          <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
          <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
        </div>
        <p class="uppercase fz-13 font-semibold" style="line-height: 1.539;">{{ text.become }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import slider from "@/components/mobile/reuseable/slider";
import {mapMutations, mapState} from "vuex";

export default {
  name: "slide3",
  components:{
    slider
  },
  methods:{
    ...mapMutations(['toggleContacts'])
  },
  computed: {
    text() {
      return require("@/assets/text/main/slide3/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  transition: all linear 0.3s;
  background: #fff;
}
.pagination > div > * {
  transition: all linear 0.3s;
}
.pagination .active {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 46, 83, 1);
}

.first {
  background: rgba(110, 117, 141, 0.1);
}
.second {
  background: rgba(110, 117, 141, 0.2);
}
.client-list-item{
  transform: scale(0.88089);
  transform-origin: center;
}
</style>
